<template>
  <div class="table-container">
    <b-row>
      <b-col align="right" class="flex-layout-button">
        <b-button
          :disabled="!formLoaded"
          class="btn btn--create btn--smaller"
          type="button"
          variant="primary"
          size="sm"
          @click="selectCreateTask(2, 'insurance_ancillaries')"
          title="Crea per Titolo"
          v-if="canVerb(resource, 'store')"
        ><base-icon name="circled_plus" width="22" height="22" />Crea per
          Titolo</b-button
        >
        <b-button
          :disabled="!formLoaded"
          class="btn btn--create btn--smaller"
          type="button"
          variant="primary"
          size="sm"
          @click="selectCreateTask(2, 'registries')"
          title="Crea per Anagrafica"
          v-if="canVerb(resource, 'store')"
        ><base-icon name="circled_plus" width="22" height="22" /> Crea per
          Anagrafica</b-button
        >
        <b-button
          :disabled="!formLoaded"
          class="btn btn--create btn--smaller"
          type="button"
          variant="primary"
          size="sm"
          @click="selectCreateTask(2, 'insurance_policies')"
          title="Crea per Polizza"
          v-if="canVerb(resource, 'store')"
        ><base-icon name="circled_plus" width="22" height="22" />Crea per
          Polizza</b-button>
      </b-col>
    </b-row>
    <tasks
      :isTableInModal="true"
      :fields="fields"
      :repository="repository"
      :resource="resource"
      :filterName="filterName"
      :filterOn="{
        byRelations: ['byRegistry', 'byInsurancePolicy'],
      }"
      :ref="tableRef"
      @edit="onEdit"
      @destroy="destroyEvent"
      :onlyActions="['edit', 'destroy']"
      noInnerWidth
      noInputPaginator
    >
    </tasks>
    <div v-if="formLoaded">
      <event-create-modal
        v-model="evt"
        :beFormCreate="beCreateForm['task']"
        :beRulesCreate="beRules['task']"
        @cancel="cancelEventCreation"
        @create="storeEvent"
        @addAppointment="onAddAppointment"
      ></event-create-modal>
      <event-change-modal
        v-model="evt"
        :beFormUpdate="beEditForm['task']"
        :beRulesUpdate="beRules['task']"
        @cancel="cancelEventChange"
        @update="putEvent({ id: task_id })"
      ></event-change-modal>
    </div>
  </div>
</template>

<script>
import Tasks from "@/components/tables/Tasks";
import FormMixin from "@/mixins/FormMixin";
import CalendarEventsAndTasksMixin from "@/mixins/CalendarEventsAndTasksMixin";
import DetailTabAutofetchTableMixin from "@/mixins/DetailTabAutofetchTableMixin";
import { toLocaleDate } from "@/utils/dates";
import { mapGetters } from "vuex";
import {getTaskableEntity} from "../../../utils/transforms";
import {getVirtualValue} from "../../../utils/ancillaries";
import BaseIcon from "@/components/BaseIcon";

export default {
  mixins: [
    CalendarEventsAndTasksMixin,
    FormMixin,
    DetailTabAutofetchTableMixin,
  ],
  name: "Notes",
  data() {
    return {
      filter: this.initFilter(),
      details: null,
      POLICY_ID: null,
      REGISTRY_ID: null,
      TASK_IDS: [0],
      filterName: "filterInsuranceAncillariesNotesDetail",
      repository: "task",
      resource: "tasks",
      tableRef: "InsuranceAncillariesNotesDetailTable",
      taskable_id: this.resourceId,
      taskable: "insurance_ancillary",
      task_type: 2,
      task_id: null,
      formLoaded: false,
      beCreateForm: {}, // define this copy for co-existende of create an edit inside the same component
      beEditForm: {}, // define this copy for co-existende of create an edit inside the same component
      fields: [
        {
          key: "title",
          label: this.getDictionary("title", "task"),
          sortable: false,
          sortKey: "title",
        },
        {
          key: "description",
          label: this.getDictionary("description", "task"),
        },
        {
          label: this.getDictionary("task_type", "task"),
          key: "task_type.text",
        },
        {
          label: this.getDictionary("is_public", "task"),
          key: "is_public.text",
        },
        {
          label: this.getDictionary("users", "task"),
          key: "users",
        },
        {
          key: "entity",
          label: this.getDictionary("Entità"),
        },
        {
          label: this.getDictionary("owner", "task"),
          key: "owner_id",
          sortable: false,
          // sortKey: "users",
          formatter: (value) => this.getOwner(value),
        },
        {
          label: this.getDictionary("created_at", "task"),
          key: "created_at",
          sortable: false,
          // sortKey: "users",
          formatter: (value) => toLocaleDate(value, "DD/MM/YYYY HH:mm:ss"),
        },
      ],
      form: {
        task: {
          id: null,
          title: null,
          description: null,
          task_type: null,
          status_task: null,
          users: null,
          owner_id: null,
          taskable: this.resourceId, //nome della relazione
          taskable_id: null, //array di ID di modelli (verosimilmente sempre 1 nelle ns. GUI)
          start: null, // date
          end: null, // date
          startTime: null,
          endTime: null,
          expired_at: null,
        },
      },
    };
  },
  components: {
    BaseIcon,
    Tasks,
  },
  methods: {
    getTaskableEntity,
    selectCreateTask(task_type, resource) {
      switch (resource) {
        case "registries":
          // nota
          this.taskable_id = this.REGISTRY_ID;
          this.taskable = "registry";
          break;
        case "insurance_policies":
          this.taskable_id = this.POLICY_ID;
          this.taskable = "insurance_policy";
          break;
        case "insurance_ancillaries":
          this.taskable_id = this.resourceId;
          this.taskable = "insurance_ancillary";
          break;
      }
      this.initDefaultFormValues({ task_type });
      this.createTask(task_type);
    },
    initFilter() {
      let init = {
        // byInsuranceAncillary: { id: this.resourceId },
        // byAttribute: { task_type: 2 },
        byAttribute: { id: this.TASK_IDS },
      };
      return init;
    },
    onEdit(id, item) {
      let entity;
      if (item) {
        entity = getTaskableEntity(
          item.registries && item.registries.length
            ? item.registries[0].pivot.taskable_type
            : item.insurance_policies && item.insurance_policies.length
              ? item.insurance_policies[0].pivot.taskable_type
              : `App\\Models\\InsuranceAncillary`
        );
      }
      this.task_id = id;
      this.taskable = entity; //nome della relazione
      let tskbl_id;
      switch (entity) {
        case "registry":
          tskbl_id = item.registries[0].id;
          break;
        case "insurance_ancillary":
          tskbl_id = id;
          break;
        case "insurance_policy":
          tskbl_id = item.insurance_policies[0].id;
          break;
        default:
          console.log("No taskable_id matched!");
          break;
      }
      this.taskable_id = tskbl_id;
      console.log("taskable", this.taskable);
      console.log("taskable_id", this.taskable_id);
      this.handleChangeClick({ id: id });
    },
    getOwner(value) {
      if (!value) return "-";
      return (
        this.getUsers().find((user) => user.value === value)?.username ?? "-"
      );
    },
    ...mapGetters("auth", {
      getUsers: "users",
    }),
  },
  props: {
    resourceId: Number,
    dbRowData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  beforeMount() {
    this.initDefaultFormValues({ task_type: this.task_type });
    this.fetchCreateForm(this.repository)
      .then(() => {
        this.beCreateForm[this.repository] = this.beEditForm[this.repository] =
          this.convertDataToCalendarEvents([this.beForm[this.repository]])[0];
        this.formLoaded = true;
      })
      .catch((error) => {
        console.error(error);
      });
    let hasInsurancePolicy;
    this.details = this.dbRowData.insurance_policy;
    this.REGISTRY_ID = this.details.registry.id;
    hasInsurancePolicy = this.dbRowData.insurance_policy ? true : false;
    if (hasInsurancePolicy) {
      this.POLICY_ID = this.dbRowData.insurance_policy.id;
    }
    let t = getVirtualValue("info", this.dbRowData).notes.rawData;
    this.TASK_IDS = t.map((e) => e.id);
    console.debug("this.TASK_IDS", this.TASK_IDS);
    this.$set(
      this.filter.byAttribute,
      "id",
      this.TASK_IDS.length ? this.TASK_IDS : [0]
    );
  },
};
</script>
<style>
.flex-layout-button {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-end;
}
</style>
